module.exports = __webpack_public_path__ + "img/图片10.868a05ce.png";